<template>

  <div>

    <el-col :span="24" style="padding:0;">
      <!--<div class="xqul">
          <ul>
              <li class="active" @click="changexq(true,1)">
                  全部
              </li>
              <li @click="changexq(false,5)">
                  南校区
              </li> 
              <li @click="changexq(false,4)">
                  北校区
              </li>
              <li @click="changexq(false,3)">
                  东校区
              </li>
              <li style="margin-right:0;" @click="changexq(false,2)">> 西校区
              </li>
          </ul>
      </div>-->
      <div class="xqul" v-if="housekeeperCapmusHouseDiv">
        <el-select v-model="param.houseId" placeholder="校区/宿舍" @change="changeSchoolCapmusHouse">
          <el-option v-for="(item,index) in campusHouseList" :key="item.houseId" :label="item.houseName" :data-campusId="item.schoolNum" :value="item.houseId"></el-option>
        </el-select>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="xqul" v-if="adminCapmusDiv">
        <ul>
          <li :class="classObject(999)" v-model="param.campusId" @click="campusClick" style="height:auto;line-height:40px;margin-top: 10px;margin-left:5px;width:auto;font-size: 13px;padding-left: 10px;padding-right: 10px;">
            全部
          </li>
          <li v-for="(item,index) in schoolarealist" :key="item.schoolNum" :label="item.schoolName" :value="item.schoolNum" :class="classObject(index)" style="height:auto;line-height:40px;margin-left:5px;margin-top: 10px; width:auto;font-size: 13px;padding-left: 10px;padding-right: 10px;" v-model="param.campusId" @click="campusClick(item,index)">
            {{item.schoolName}}
          </li>
        </ul>
      </div>
    </el-col>
    <el-col :span="24" style="padding:0;" v-if="isall">
      <div style="text-align: right;padding-right: 20px">
        <div style="float:right;height: 10px;">空床位</div>
        <div style="margin-right: 5px;float:right;width: 10px;height: 10px;background-color:#00CDCD;border-radius: 50%;-moz-border-radius: 50%;-webkit-border-radius: 50%;"></div>
        <div style="float:right;margin-right: 20px;height: 10px;">已入住</div>
        <div style="margin-right: 5px;float:right;width: 10px;height: 10px;background-color:#FFB324;border-radius: 50%;-moz-border-radius: 50%;-webkit-border-radius: 50%;"></div>
      </div>
      <div class="eacharts" style="padding:20px;">
        <div class="bars">
          <!--<div ref="myEchartBar" style="height:700px;width:100%;padding-top:20px;" class="myEchartBar"></div>-->
          <div id="myEchartBarDiv"></div>
        </div>
        <div class="bars" style="margin-top: 30px;">

          <!--全部校区-->
          <div style="min-height:700px;width:100%;    margin-top: 30px;" class="myEchartPie" v-if="allCampusDiv">
            <div>
              <el-button style="float:right;" @click="exportStatisSchoolBedList(1)">
                <img src="../../../static/images/accommodationManagement/export.png" style="vertical-align: middle;" />导出Excel</el-button>
            </div>
            <el-table border stripe :data="tableData" header-row-class-name="table-header" fit key="allCampusTable">

              <el-table-column prop="order" label="序号" width="55" align="center">
              </el-table-column>
              <el-table-column prop="campusnName" label="校区" width="254" align="center">
              </el-table-column>
              <el-table-column prop="houseCount" label="楼栋数" width="220" align="center">
              </el-table-column>
              <el-table-column prop="dormCount" label="宿舍数" align="center">
              </el-table-column>
              <el-table-column prop="totalBed" label="总床位" align="center">
              </el-table-column>
              <el-table-column prop="useBed" label="已入住" align="center">
              </el-table-column>
              <el-table-column prop="noUeBed" label="空床位" align="center">
              </el-table-column>

            </el-table>
          </div>

          <!--校区全部楼栋-->
          <div style="min-height:700px;width:100%;margin-top:50px;" class="myEchartPie" v-if="campusAllHouseDiv">
            <div style="margin-top:50px">
              <el-button style="float:right;" @click="exportStatisSchoolBedList(2)">
                <img src="../../../static/images/accommodationManagement/export.png" style="vertical-align: middle;" />导出Excel</el-button>
            </div>
            <el-table border stripe :data="tableData" header-row-class-name="table-header" key="campusAllHouseTable">
              <el-table-column prop="order" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="houseName" label="楼栋" width="200" align="center">
              </el-table-column>
              <el-table-column prop="dormCount" label="宿舍数" align="center">
              </el-table-column>
              <el-table-column prop="totalBed" label="总床位" align="center">
              </el-table-column>
              <el-table-column prop="useBed" label="已入住" align="center">
              </el-table-column>
              <el-table-column prop="noUeBed" label="空床位" align="center">
              </el-table-column>
              <el-table-column prop="buildingUnit" label="操作" align="center">
                <template slot-scope="scope">
                  <a href="javascript:void(0);" @click="houseDetail(scope.row)">
                    查看详情
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 楼栋查看详情 -->
          <div ref="myEchartPie" style="min-height:700px;width:100%;margin-top:50px;" class="myEchartPie" v-if="houseDetailDiv">
            <el-button style="float:left;" @click="houseDetailBack()">
              <i class="el-icon-arrow-left" style="color: #00a0e9"></i>返回</el-button>
            <el-button style="float:right;" @click="exportStatisSchoolBuildDetaiList()">
              <img src="../../../static/images/accommodationManagement/export.png" style="vertical-align: middle;" />导出Excel</el-button>
            <li style="float:right;list-style: none;">
              <div class="search bar6">
                <input type="text" placeholder="请输入宿舍名称查询" style="border: 1px solid #c0c4cc;border-radius: 5px;background: transparent;top: 0;right: 0;height: 30px;line-height: 30px;outline: none;padding: 5px;margin-left: 5px;" v-model="param.dormName" name="dormName">
                <el-button type="submit" icon="el-icon-search" @click="searcByParam('house')">查询</el-button>
              </div>
            </li>
            <li style="float:right;list-style: none;margin-left: 5px;">
              楼层:
              <el-select v-model="param.floorId" placeholder="楼层">
                <el-option value="" selected>全部</el-option>
                <el-option v-for="(item,index) in houseFloorList" :key="item.floorId" :label="item.floorName" :value="item.floorId"></el-option>
              </el-select>
            </li>
            <li style="float:right;list-style: none;margin-left: 5px;">
              是否有空床位：
              <el-select v-model="param.status">
                <el-option v-for="(item,index) in statusList" :key="item.statusValue" :label="item.statusName" :value="item.statusValue"></el-option>
              </el-select>
            </li>
            <el-table border stripe :data="tableData" header-row-class-name="table-header" key="houseDetailTable">
              <el-table-column prop="order" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="dormName" label="宿舍" width="200" align="center">
              </el-table-column>
              <el-table-column prop="floorName" label="楼层" align="center">
              </el-table-column>
              <el-table-column prop="totalBed" label="总床位" align="center">
              </el-table-column>
              <el-table-column prop="useBed" label="已入住" align="center">
              </el-table-column>
              <el-table-column prop="noUeBed" label="空床位" align="center">
              </el-table-column>
            </el-table>
            <div class="pagination-container ">
              <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination"></v-pagination>
            </div>
          </div>

          <!--宿管员楼栋-->
          <div ref="myEchartPie" style="min-height:700px;width:100%;margin-top:50px;" class="myEchartPie" v-if="houseAdminDiv">
            <el-button style="float:right;" @click="exportStatisSchoolBedList(3)">
              <img src="../../../static/images/accommodationManagement/export.png" style="vertical-align: middle;" />导出Excel</el-button>
            <el-table border stripe :data="tableData" header-row-class-name="table-header" key="houseAdminTable">
              <el-table-column prop="order" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="floorName" label="楼层" width="200" align="center">
              </el-table-column>
              <el-table-column prop="dormCount" label="宿舍数" align="center">
              </el-table-column>
              <el-table-column prop="totalBed" label="总床位" align="center">
              </el-table-column>
              <el-table-column prop="useBed" label="已入住" align="center">
              </el-table-column>
              <el-table-column prop="noUeBed" label="空床位" align="center">
              </el-table-column>
              <el-table-column prop="buildingUnit" label="操作" align="center">
                <template slot-scope="scope">
                  <a href="javascript:void(0);" @click="floorDetail(scope.row)">
                    查看详情
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!--宿管员楼层查看详情-->
          <div ref="myEchartPie" style="min-height:700px;width:100%;margin-top:50px;" class="myEchartPie" v-if="houseAdminFloorDetailDiv">
            <el-button style="float:left;" @click="floorDetailBack()">
              <i class="el-icon-arrow-left" style="color: #00a0e9"></i>返回</el-button>
            <el-button style="float:right;" @click="exportStatisSchoolFloorDetaiList()">
              <img src="../../../static/images/accommodationManagement/export.png" style="vertical-align: middle;" />导出Excel</el-button>
            <li style="float:right;list-style: none;">
              <div class="search bar6">
                <input type="text" placeholder="请输入宿舍名称查询" style="border: 1px solid #c0c4cc;border-radius: 5px;background: transparent;top: 0;right: 0;height: 30px;line-height: 30px;outline: none;padding: 5px;margin-left: 5px;" v-model="param.dormNameHouseAdmin" name="dormNameHouseAdmin">
                <el-button type="submit" icon="el-icon-search" @click="searcByParam('floor')">查询</el-button>
              </div>
            </li>
            <li style="float:right;list-style: none;margin-left: 5px;">
              楼层:
              <el-select v-model="param.floorId" placeholder="楼层">
                <el-option value="" selected>全部</el-option>
                <el-option v-for="(item,index) in houseFloorList" :key="item.floorId" :label="item.floorName" :value="item.floorId"></el-option>
              </el-select>
            </li>
            <li style="float:right;list-style: none;margin-left: 5px;">
              是否有空床位：
              <el-select v-model="param.status">
                <el-option v-for="(item,index) in statusList" :key="item.statusValue" :label="item.statusName" :value="item.statusValue"></el-option>
              </el-select>
            </li>
            <el-table border stripe :data="tableData" header-row-class-name="table-header" key="houseAdminFloorDetailTable">
              <el-table-column prop="order" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="dormName" label="宿舍" width="200" align="center">
              </el-table-column>
              <el-table-column prop="totalBed" label="总床位" align="center">
              </el-table-column>
              <el-table-column prop="useBed" label="已入住" align="center">
              </el-table-column>
              <el-table-column prop="noUeBed" label="空床位" align="center">
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
    </el-col>
  </div>
</template>
<script>
  import Api from '@/api';
  import {
    session
  } from '@/util';
  import basetable from '@/mixins/base-table';
  export default {
    mixins: [basetable],
    data () {
      return {
        isall: true,
        allCampusDiv: true,
        campusAllHouseDiv: false,
        houseDetailDiv: false,
        houseAdminDiv: false,
        houseAdminFloorDetailDiv: false,
        width: '100%',
        height: '500px',
        chart: null,
        campusHouseList: [],
        userInfo: '',
        housekeeperCapmusHouseDiv: false,
        adminCapmusDiv: false,
        campusId: '',
        schoolId: '',
        isActive: 999,
        param: {
          schoolId: '',
          campusId: '',
          houseId: '',
          floorId: '',
          dormName: '',
          status: '',
          dormNameHouseAdmin: '',
        },
        bardata: [],
        tableData: [],
        schoolarealist: [],
        bardataCurrCampusAllHouseBackStatis: [],
        legenddataCurrCampusAllHouseBackStatis: [],
        pagetype: '',
        houseFloorList: [],
        statusList: [{
          statusName: '全部',
          statusValue: '',
        }, {
          statusName: '无',
          statusValue: '1',
        }, {
          statusName: '有',
          statusValue: '0',
        }]
      };

    },
    watch: {

    },
    methods: {
      classObject (index) {
        if (this.isActive == index) {
          return "active";
        } else {
          return "";
        }
      },
      getSchoolarealist () {
        return new Promise(function (resolve, reject) {
          Api.summary.querySchoolCapmus().then(res => {
            if (res.code == 0) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        })
      },
      campusClick (item, index) {
        console.log(item)
        this.param.dormName = '';
        if (item.schoolNum != undefined && item.schoolNum != 'undefined') {
          this.campusId = item.schoolNum + "";
          this.param.campusId = item.schoolNum + "";
          this.isActive = index;
          this.allCampusDiv = false;
          this.campusAllHouseDiv = true;
          this.houseDetailDiv = false;
          this.houseAdminFloorDetailDiv = false;
          let statisSchoolBedListPromise = this.statisSchoolBedList(this.schoolId, this.campusId, null, 2)
          statisSchoolBedListPromise.then(statisSchoolBedListRes => {
            if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
            this.divMoreBar(statisSchoolBedListRes.data.dormitoryStatisList)
            //this.drawBarCurrCampusAllHouseBackStatis()
            ////列表
            this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
          }
        })

        } else {
          this.campusId = '';
          this.param.campusId = "";
          this.isActive = 999;
          this.allCampusDiv = true;
          this.campusAllHouseDiv = false;
          this.houseDetailDiv = false;
          this.houseAdminFloorDetailDiv = false;
          let statisSchoolBedListPromise = this.statisSchoolBedList(this.schoolId, null, null, 1)

          statisSchoolBedListPromise.then(statisSchoolBedListRes => {
            if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
            if (statisSchoolBedListRes.data.totalList != null && statisSchoolBedListRes.data.totalList.length > 0) {
              this.drawBarSchoolBedStatisticsr(statisSchoolBedListRes.data.totalList[0])
            }
            if (statisSchoolBedListRes.data.totalList != null && statisSchoolBedListRes.data.dormitoryStatisList.length >
              0) {
              this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
            }
          }
        })

        }
      },
      changeSchoolCapmusHouse (val) {
        this.param.dormName = '';
        for (let i = 0; i < this.campusHouseList.length; i++) {
          let house = this.campusHouseList[i];
          if (house.houseId == val) {
            this.campusId = house.schoolNum + "";
            break;
          }
        }
        this.allCampusDiv = false;
        this.campusAllHouseDiv = false;
        this.houseDetailDiv = false;
        this.houseAdminFloorDetailDiv = false;
        this.houseAdminDiv = true;
        this.tableData = [];
        this.drawBarSchoolBedStatisticsr(null)
        let statisSchoolBedListPromise = this.statisSchoolBedList(this.schoolId, this.campusId, val, 3)
        statisSchoolBedListPromise.then(statisSchoolBedListRes => {
          if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
          if (statisSchoolBedListRes.data.totalList != null && statisSchoolBedListRes.data.totalList.length > 0) {
            this.drawBarSchoolBedStatisticsr(statisSchoolBedListRes.data.totalList[0])
          }
          this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
        }
      })
      },
      queryHouseByManagerUser () {
        return new Promise(function (resolve, reject) {
          Api.summary.queryHouseByManagerUser().then(res => {
            if (res.code == 0) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        })
      },
      getFloorListByHouseId (houseId) {
        return new Promise(function (resolve, reject) {
          Api.summary.getFloorListByHouseId(houseId).then(res => {
            if (res.code == 0) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        })
      },
      statisSchoolBedList (schoolId, campusId, houseId, status) {
        let str = "schoolId=" + schoolId;
        if (campusId) {
          str += "&schoolNum=" + campusId;
        }
        if (houseId) {
          str += "&houseId=" + houseId;
        }
        if (status) {
          str += "&status=" + status;
        }
        return new Promise(function (resolve, reject) {
          Api.AccommodationManagement.statisSchoolBedList(str).then(res => {
            if (res.code == 0) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        })
      },
      loadData () {
        let str = "schoolId=" + this.param.schoolId;
        if (this.param.campusId) {
          str += "&schoolNum=" + this.param.campusId;
        }
        if (this.param.houseId) {
          str += "&houseId=" + this.param.houseId;
        }
        if (this.param.floorId) {
          str += "&floorId=" + this.param.floorId;
        }
        if (this.param.status) {
          str += "&status=" + this.param.status;
        }
        if (this.pagetype == "house") {
          if (this.param.dormName) {
            str += "&dormitoryName=" + this.param.dormName;
          }
          console.log(str);
          Api.AccommodationManagement.statisSchoolBuildDetaiList(str, this.page, this.size).then(res => {
            if (res.code == 0) {
            this.total = res.data.total;
            this.tableDataPush(res.data.list);
          }
        })
        } else if (this.pagetype == "floor") {
          if (this.param.dormNameHouseAdmin) {
            str += "&dormitoryName=" + this.param.dormNameHouseAdmin;
          }
          console.log(str);
          Api.AccommodationManagement.statisSchoolFloorDetaiList(str, this.page, this.size).then(res => {
            if (res.code == 0) {
            this.total = res.data.total;
            this.tableDataPush(res.data.list);
          }
        })
        }
      },
      houseDetail (row) {
        this.houseDetailDiv = true;
        this.campusAllHouseDiv = false;
        this.allCampusDiv = false;
        this.param.campusId = row.campusId + "";
        this.param.houseId = row.houseId;
        this.pagetype = "house";
        this.loadData();

        ////楼层
        this.houseFloorList = [];
        let floorPromise = this.getFloorListByHouseId(this.param.houseId);
        floorPromise.then(floorRes => {
          if (floorRes.code == 0 && floorRes.data != null && floorRes.data.length > 0) {
          this.houseFloorList = floorRes.data;
        }
      })
        this.param.status = '';
        this.param.floorId = ''
      },
      houseDetailBack () {
        this.houseDetailDiv = false;
        this.allCampusDiv = false;
        this.param.dormName = '';
        this.param.floorId = '';
        let statisSchoolBedListPromise = this.statisSchoolBedList(this.param.schoolId, this.param.campusId, null, 2)
        statisSchoolBedListPromise.then(statisSchoolBedListRes => {
          if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
          ////列表
          this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
        }
      })
        this.campusAllHouseDiv = true;
      },
      floorDetail (row) {
        this.houseDetailDiv = false;
        this.campusAllHouseDiv = false;
        this.allCampusDiv = false;
        this.houseAdminFloorDetailDiv = true;
        this.houseAdminDiv = false;
        if (row.campusId) {
          this.param.campusId = row.campusId + "";
        }
        if (row.houseId) {
          this.param.houseId = row.houseId;
        }
        this.param.floorId = row.floorId;
        this.pagetype = "floor";
        this.loadData();

        ////楼层
        this.houseFloorList = [];
        let floorPromise = this.getFloorListByHouseId(this.param.houseId);
        floorPromise.then(floorRes => {
          if (floorRes.code == 0 && floorRes.data != null && floorRes.data.length > 0) {
          this.houseFloorList = floorRes.data;
        }
      })
        //this.param.status = '';
        //this.param.floorId = ''
      },
      floorDetailBack () {
        this.houseDetailDiv = false;
        this.campusAllHouseDiv = false;
        this.allCampusDiv = false;
        this.houseAdminFloorDetailDiv = false;
        this.param.dormNameHouseAdmin = '';
        this.param.status = '';
        let statisSchoolBedListPromise = this.statisSchoolBedList(this.param.schoolId, this.param.campusId, this.param.houseId,
          3)
        statisSchoolBedListPromise.then(statisSchoolBedListRes => {
          if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
          this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
        }
      })
        this.houseAdminDiv = true;
      },
      searcByParam (pagetype) {
        this.pagetype = pagetype;
        this.loadData();
      },
      tableDataPush (resData) {
        this.tableData = [];
        let index = 0;
        for (let item of resData) {
          index++;
          this.tableData.push({
            order: index,
            campusnName: item.schoolCampusName == undefined ? '' : item.schoolCampusName,
            houseName: item.houseName == undefined ? '' : item.houseName,
            dormName: item.dormitoryName == undefined ? '' : item.dormitoryName,
            floorName: item.floorName == undefined ? '' : item.floorName,
            houseCount: item.buildingNum == undefined ? '' : item.buildingNum,
            dormCount: item.houseNum == undefined ? '' : item.houseNum,
            totalBed: item.totalBed,
            useBed: item.useBed,
            noUeBed: item.emptyBed,
            floorId: item.floorId,
            campusId: item.schoolCampusId,
            houseId: item.houseId
          })
        }
      },
      drawBarSchoolBedStatisticsr (bardata) {
        // 基于准备好的dom，初始化echarts实例
        var myEchartBarDiv = document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        var barDiv = document.createElement("div");
        barDiv.style.height = "700px";
        myEchartBarDiv.appendChild(barDiv);
        //this.chart = this.$echarts.init(this.$refs.myEchartBar);
        var myBarchart = this.$echarts.init(barDiv);
        if (bardata != null) {
          // 绘制图表
          myBarchart.setOption({
            title: {
              //text: '总床位：'+bardata.totalNum,
              subtext: '',
              x: 'center',
              y: 'bottom'
            },
            tooltip: {
              trigger: 'item',
              //formatter: "{a} <br/>{b}:占比{d}%"
            },
            /*legend: {
                show: true,
                orient: 'vertical',
                x: 'right',
                y: 'bottom',
                data: ['空床位', '已入住']
            },*/
            toolbox: {
              show: false,
              feature: {
                mark: {
                  show: true
                },
                dataView: {
                  show: true,
                  readOnly: false
                },
                magicType: {
                  show: true,
                  type: ['pie', 'funnel'],
                  option: {
                    funnel: {
                      x: '25%',
                      width: '50%',
                      funnelAlign: 'left',
                      max: 1548
                    }
                  }
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            calculable: true,
            series: [{
              name: '住宿统计',
              type: 'pie',
              //minAngle:.5,  /*最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互*/
              radius: '55%', //圆的大小
              center: ['50%', '50%'], //圆的位置
              data: [{
                value: bardata.notUseNum,
                name: '空床位',
                point: bardata.totalNum == 0 || bardata.notUseNum == 0 ? "" : "空床位" + "\n" + this.keepTwoDecimal((bardata.notUseNum /
                  bardata.totalNum) * 100) + "%" + "\n" + bardata.notUseNum + "人",
              },
                {
                  value: bardata.useNum,
                  name: '已入住',
                  point: bardata.totalNum == 0 || bardata.useNum == 0 ? "" : "已入住" + "\n" + this.keepTwoDecimal((bardata.useNum /
                    bardata.totalNum) * 100) + "%" + "\n" + bardata.useNum + "人",
                },
              ],
              itemStyle: {
                normal: {
                  label: { //此处为指示线文字
                    show: true,
                    position: 'inner', //标签的位置
                    textStyle: {
                      fontWeight: 200,
                      fontSize: 14, //文字的字体大小
                      color: '#000000',
                      align: 'center',
                    },
                    formatter: function (p) { //指示线对应文字
                      var data = p.data.point;
                      return data;
                    }
                  },
                  labelLine: { //指示线状态
                    show: true,
                    smooth: 0.2,
                    length: 10,
                    length2: 20
                  }
                }
              }
            }],
            color: ['#00CDCD', '#FFB324'] //块的颜色
          }, true);
        }
      },
      drawBarCurrCampusAllHouseBackStatis () {
        // 基于准备好的dom，初始化echarts实例

        this.chart = this.$echarts.init(this.$refs.myEchartBar);
        this.chart.clear();
        // 绘制图表
        this.chart.setOption({
          title: {
            text: '',
            subtext: '',
            x: 'center',
            y: 'bottom'
          },
          legend: {
            orient: 'vertical',
            x: 'right',
            y: 'bottom',
            data: ['空床位', '已入住']
          },
          toolbox: {
            show: false,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['pie', 'funnel'],
                option: {
                  funnel: {
                    x: '25%',
                    width: '50%',
                    funnelAlign: 'left',
                    max: 1548
                  }
                }
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          calculable: true,
          series: this.bardataCurrCampusAllHouseBackStatis,
          color: ['#00CDCD', '#FFB324'] //块的颜色
        }, true);
      },
      backStatisConvert (bardata) {
        this.bardataCurrCampusAllHouseBackStatis = [];
        this.legenddataCurrCampusAllHouseBackStatis = [];
        let size = bardata.length;
        let radiusSize = 75;
        let centerX = 0;
        let centerY = 0;
        let addX = 0;
        if (size == 1) {
          radiusSize = 65;
          centerX = 25;
          centerY = 50;
          addX = 25;
        }
        if (size == 2) {
          radiusSize = 50;
          //centerX = 25;
          centerY = 35;
          addX = 35;
        }
        if (size > 2) {
          radiusSize = 35;
          centerY = 25;
          addX = 20;
        }
        if (size > 5) {
          radiusSize = 30;
          centerY = 25;
          addX = 20;
        }
        if (size > 8) {
          radiusSize = 30;

        }
        let itemIndex = 0;
        let addNum = 0;
        for (let item of bardata) {
          itemIndex++;
          centerX = centerX + addX
          this.bardataCurrCampusAllHouseBackStatis.push({
            name: item.houseName + '，总床位 ' + item.totalBed,
            type: 'pie',
            radius: radiusSize + '%', //圆的大小
            ////radius : [10, 50],
            ////center: ['50%', '50%'], //圆的位置
            center: [centerX + '%', centerY + '%'],
            data: [{
              value: item.emptyBed,
              name: '空床位',
              point: "空床位\n" + (item.totalBed == 0 || item.emptyBed == 0 ? "0%" : this.keepTwoDecimal((item.emptyBed / item
                .totalBed) * 100) + "%") + "\n" + item.emptyBed + "人",
            },
              {
                value: item.useBed,
                name: '已入住',
                point: "已入住\n" + (item.totalBed == 0 || item.useBed == 0 ? "0%" : this.keepTwoDecimal((item.useBed / item.totalBed) *
                  100) + "%") + "\n" + item.useBed + "人",
              },
            ],
            itemStyle: {
              normal: {
                label: { //此处为指示线文字
                  show: true,
                  position: 'inner', //标签的位置
                  textStyle: {
                    fontWeight: 200,
                    fontSize: 14, //文字的字体大小
                    color: '#000000',
                    align: 'center',
                  },
                  formatter: function (p) { //指示线对应文字
                    var data = p.data.point;
                    return data;
                  }
                },
                labelLine: { //指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                }
              }
            }
          })
        }
      },
      divMoreBar (bardata) {
        var size = bardata.length;
        var radiusSize = 75;
        var centerX = 48;
        var centerY = 50;
        var divHeight = "700px";
        var divWidth = "100%";

        if (size == 2) {
          divWidth = "45%";
        }
        if (size > 2) {
          divHeight = "300px";
          divWidth = "270px";
        }
        /*if(size >5){
          radiusSize = 30;
          centerX = 25;
          centerY = 50;
        }
        if(size > 8){
          radiusSize = 30;
        }*/
        let itemIndex = 0;
        let addNum = 0;
        var myEchartBarDiv = document.getElementById("myEchartBarDiv");
        myEchartBarDiv.innerHTML = "";
        for (let item of bardata) {
          if (item) {
            //itemIndex++;
            //centerX = centerX + addX
            ////多画布
            var barDiv = document.createElement("div");
            barDiv.style.height = divHeight
            barDiv.style.width = divWidth
            barDiv.style.cssFloat = "left";
            barDiv.style.marginLeft = "20px";
            //barDiv.setAttribute("class","barDiv");
            myEchartBarDiv.appendChild(barDiv);
            var myBarchart = this.$echarts.init(barDiv);
            // 绘制图表
            myBarchart.setOption({
              title: {
                text: item.houseName,
                subtext: '',
                x: 'center',
                y: 'bottom'
              },
              /*legend: {
                orient: 'vertical',
                x: 'right',
                y: 'bottom',
                data: ['空床位', '已入住']
              },*/
              toolbox: {
                show: false,
                feature: {
                  mark: {
                    show: true
                  },
                  dataView: {
                    show: true,
                    readOnly: false
                  },
                  magicType: {
                    show: true,
                    type: ['pie', 'funnel'],
                    option: {
                      funnel: {
                        x: '25%',
                        width: '50%',
                        funnelAlign: 'left',
                        max: 1548
                      }
                    }
                  },
                  restore: {
                    show: true
                  },
                  saveAsImage: {
                    show: true
                  }
                }
              },
              calculable: true,
              series: [{
                name: item.houseName,
                type: 'pie',
                //minAngle:.5,  /*最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互*/
                radius: radiusSize + '%', //圆的大小
                ////radius : [10, 50],
                ////center: ['50%', '50%'], //圆的位置
                center: [centerX + '%', centerY + '%'],
                data: [{
                  value: item.emptyBed,
                  name: '空床位',
                  point: item.totalBed == 0 || item.emptyBed == 0 ? "" : "空床位\n" + this.keepTwoDecimal((item.emptyBed / item
                    .totalBed) * 100) + "%" + "\n" + item.emptyBed + "人",
                },
                  {
                    value: item.useBed,
                    name: '已入住',
                    point: item.totalBed == 0 || item.useBed == 0 ? "" : "已入住\n" + this.keepTwoDecimal((item.useBed / item.totalBed) *
                      100) + "%" + "\n" + item.useBed + "人",
                  },
                ],
                itemStyle: {
                  normal: {
                    label: { //此处为指示线文字
                      show: true,
                      position: 'inner', //标签的位置
                      textStyle: {
                        fontWeight: 200,
                        fontSize: 14, //文字的字体大小
                        color: '#000000',
                        align: 'center',
                      },
                      formatter: function (p) { //指示线对应文字
                        var data = p.data.point;
                        return data;
                      }
                    },
                    labelLine: { //指示线状态
                      show: true,
                      smooth: 0.2,
                      length: 10,
                      length2: 20
                    }
                  }
                }
              }],
              color: ['#00CDCD', '#FFB324'] //块的颜色
            }, true);
          }
        }
        var bothDiv = document.createElement("div");
        bothDiv.style.clear = "both";
        myEchartBarDiv.appendChild(bothDiv);
      },
      exportStatisSchoolBedList (val) {
        let str = "schoolId=" + this.param.schoolId;
        if (this.param.campusId) {
          str += "&schoolNum=" + this.param.campusId;
        }
        if (this.param.houseId) {
          str += "&houseId=" + this.param.houseId;
        }
        if (this.param.floorId) {
          str += "&floorId=" + this.param.floorId;
        }
        if (this.param.dormName) {
          str += "&dormitoryName=" + this.param.dormName;
        }
        str += "&status=" + val;
        Api.AccommodationManagement.exportStatisSchoolBedList(str).then((response) => {
          //创建一个blob对象,file的一种
          let blob = new Blob([response], {
            type: 'application/x-xls'
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = '学生住宿情况统计.xls';
        link.click()
      })
      },
      exportStatisSchoolBuildDetaiList () {
        let str = "schoolId=" + this.param.schoolId;
        if (this.param.campusId) {
          str += "&schoolNum=" + this.param.campusId;
        }
        if (this.param.houseId) {
          str += "&houseId=" + this.param.houseId;
        }
        if (this.param.floorId) {
          str += "&floorId=" + this.param.floorId;
        }
        if (this.param.dormName) {
          str += "&dormitoryName=" + this.param.dormName;
        }
        if (this.param.status) {
          str += "&status=" + this.param.status;
        }
        Api.AccommodationManagement.exportStatisSchoolBuildDetaiList(str).then((response) => {
          //创建一个blob对象,file的一种
          let blob = new Blob([response], {
            type: 'application/x-xls'
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = '学生住宿情况统计-楼栋.xls';
        link.click()
      })
      },
      exportStatisSchoolFloorDetaiList () {
        let str = "schoolId=" + this.param.schoolId;
        if (this.param.campusId) {
          str += "&schoolNum=" + this.param.campusId;
        }
        if (this.param.houseId) {
          str += "&houseId=" + this.param.houseId;
        }
        if (this.param.floorId) {
          str += "&floorId=" + this.param.floorId;
        }
        if (this.param.dormName) {
          str += "&dormitoryName=" + this.param.dormName;
        }
        if (this.param.status) {
          str += "&status=" + this.param.status;
        }
        Api.AccommodationManagement.exportStatisSchoolFloorDetaiList(str).then((response) => {
          //创建一个blob对象,file的一种
          let blob = new Blob([response], {
            type: 'application/x-xls'
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = '学生住宿情况统计-楼层.xls';
        link.click()
      })
      },
      keepTwoDecimal (num) {
        var result = parseFloat(num);
        if (isNaN(result)) {
          alert('传递参数错误，请检查！');
          return false;
        }
        result = Math.round(num * 100) / 100;
        return result;
      }

    },
    mounted () {
      //this.drawBar(this.bardata);
      let user = session('user');
      let roleName = '';
      let tsr = user.tsr;
      this.schoolId = user.schoolId;
      this.param.schoolId = user.schoolId;
      if (tsr != null) {
        roleName = tsr.roleName;
      }

      //roleName = "学校管理员";
      //roleName = "后勤管理员";
      if (roleName != null && (roleName == "学校管理员" || roleName == "后勤管理员")) {
        this.housekeeperCapmusHouseDiv = false
        this.adminCapmusDiv = true

        let Promise = this.getSchoolarealist();
        Promise.then(res => {
          if (res.code == 0 && res.data != null && res.data.length > 0) {
          this.schoolarealist = res.data;
        }
      })

        let statisSchoolBedListPromise = this.statisSchoolBedList(user.schoolId, null, null, 1)
        statisSchoolBedListPromise.then(statisSchoolBedListRes => {
          if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
          if (statisSchoolBedListRes.data.totalList != null && statisSchoolBedListRes.data.totalList.length > 0) {
            this.drawBarSchoolBedStatisticsr(statisSchoolBedListRes.data.totalList[0])
          }
          this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);
        }
      })

      } else if (roleName != null && roleName == "宿舍管理员") {
        this.housekeeperCapmusHouseDiv = true
        this.adminCapmusDiv = false

        let queryHouseByManagerUserPromise = this.queryHouseByManagerUser();
        queryHouseByManagerUserPromise.then(queryHouseByManagerUserRes => {
          if (queryHouseByManagerUserRes.code == 0 && queryHouseByManagerUserRes.data != null &&
        queryHouseByManagerUserRes.data.length > 0) {
          this.campusHouseList = queryHouseByManagerUserRes.data;
          let houseOne = this.campusHouseList[0];
          console.log(JSON.stringify(houseOne));
          this.param.houseId = houseOne.houseId;
          this.param.campusId = houseOne.schoolNum + "";
          this.houseDetailDiv = false;
          this.campusAllHouseDiv = false;
          this.allCampusDiv = false;
          this.houseAdminFloorDetailDiv = false;

          let statisSchoolBedListPromise = this.statisSchoolBedList(user.schoolId, houseOne.schoolNum + "", houseOne.houseId,
            3)
          statisSchoolBedListPromise.then(statisSchoolBedListRes => {
            if (statisSchoolBedListRes.code == 0 && statisSchoolBedListRes.data != null) {
            if (statisSchoolBedListRes.data.totalList != null && statisSchoolBedListRes.data.totalList.length > 0) {
              this.drawBarSchoolBedStatisticsr(statisSchoolBedListRes.data.totalList[0])
            }
            this.tableDataPush(statisSchoolBedListRes.data.dormitoryStatisList);

          }
        })
          this.houseAdminDiv = true;
        }
      })
      }
    },
    created () {

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .center {
  .container {
    width: 1200px;
  ul.nav-header {
    border-bottom: 2px solid #dcdfe6;
  li {
    display: inline-block;
    position: relative;
    bottom: -2px;
    padding-bottom: 16px;
    margin-right: 60px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
  }
  li.router-link-active {
    color: #26aef3;
    border-bottom: 2px solid #26aef3;
  }
  }
  .titlepanel {
    width: 100%;
    height: 48px;
    background: white;
    line-height: 48px;
    font-size: 16px;
    margin-top: 20px;
    text-indent: 1em;
  }
  .xqul {
    width: 100%;
    /*height: 118px;*/
    margin-top: 20px;
  ul {
    width: 100%;
    height: 100%;
  li {
    height: 100%;
    background: white;
    border-radius: 4px;
    font-size: 20px;
    margin-right: 10px;
    width: 224px;
    float: left;
    text-align: center;
    line-height: 118px;
    transition: 0.3s;
    cursor: pointer;
  }
  li.active {
    color: #26aef3;
  }
  li:hover {
    border-radius: 6px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.78);
  }
  }
  }
  .eacharts {
    background: white;
    margin-top: 20px;
  .bars {
    /*height: 690px;*/
    widows: 100%;
  .myEchartBar {
    margin: auto;
  }
  }
  }
  .searchpanel {
    height: 48px;
    line-height: 48px;
    background: white;
    list-style: none;
  li {
    list-style: none;
    float: left;
    margin-left: 10px;
  img {
    vertical-align: middle;
  }
  }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/accommodationManagement/accommodationManagement.vue